// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.s10DaZ0ShlaK_I3EeCfC {
  display: flex;
  justify-content: right;
  align-items: center;
  margin-bottom: 0.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/ColumnSelector/ToggleButton/styles.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;AACvB","sourcesContent":[".button {\n  display: flex;\n  justify-content: right;\n  align-items: center;\n  margin-bottom: 0.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `s10DaZ0ShlaK_I3EeCfC`
};
export default ___CSS_LOADER_EXPORT___;
